var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "),(_vm.isWarning)?_c('b-icon',{attrs:{"type":"is-warning","pack":"fas","icon":"exclamation-triangle","size":_vm.iconSize}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }